import { Component, Input, Output, EventEmitter } from '@angular/core'
import { EventHandlerService } from './../core/event-handler/event-handler.service'

@Component({
  standalone: false,
  selector: 'se-empty-state',
  host: {'class': 'se-empty-state'},
  templateUrl: './empty-state.component.html',
  
})
export class SeEmptyStateComponent {

  public showButton: boolean
  public showLink: boolean
  public isCentered: boolean
  public isSubtle: Boolean
  public emptyStateClass: string

  @Input('se-data-action-label') actionLabel: string
  @Input('se-data-action-url') actionUrl: string
  @Input('se-data-action-target') actionTarget: string
  @Input('se-data-centered') centered: boolean
  @Input('se-data-title') title: string
  @Input('se-data-icon') icon: string
  @Input('se-data-icon-accent') iconAccent: boolean
  @Input('se-data-subtle') subtle: boolean
  @Output('seDataAction') actionHandler: EventEmitter<any> = new EventEmitter()

  constructor(private eventHandlerService: EventHandlerService) {
    // empty block
  }

  ngOnInit(): void {
    this.initialize()
  }

  ngOnChanges(): void {
    this.initialize()
  }

  private initialize(): void {
    const hasLabel = !!this.actionLabel
    this.showLink = !!this.actionUrl && hasLabel
    this.showButton = !this.showLink && !!this.hasAnAction() && hasLabel
    this.isCentered = !!this.centered
    this.isSubtle = !!this.subtle
    this.initClasses()
  }

  private initClasses(): void {

    const classes = []

    if (this.isCentered) {
      classes.push('se-empty-state--vertically-centered')
    }

    if (this.isSubtle) {
      classes.push('se-empty-state--subtle')
    }

    this.emptyStateClass = classes.join(', ')

  }

  public doAction($event: Event): void {
    this.actionHandler.emit($event)
  }

  private hasAnAction(): boolean {
    return this.eventHandlerService.hasValidEventHandler(this.actionHandler)
  }

}
